import { render, staticRenderFns } from "./plus-button.vue?vue&type=template&id=054d6532&scoped=true"
import script from "./plus-button.vue?vue&type=script&lang=js"
export * from "./plus-button.vue?vue&type=script&lang=js"
import style0 from "./plus-button.vue?vue&type=style&index=0&id=054d6532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054d6532",
  null
  
)

export default component.exports